import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {CONFIRM_TIMEOUT_MS} from "../constants/reservation_constants";
import {
    IReservationAvailabilityResponse,
    IReservationConfirmPayload,
    IReservationConfirmResponse,
    IReservationInitiatePayload,
    IReservationInitiateResponse
} from "../types/IReservationApi";
import {ReservationAvailabilityStatus} from "../types/ReservationAvailabilityStatus";
import {transformReservationAvailabilityError, transformReservationError} from "../utils/report_reservation_error";

const reservationAvailabilityApiLink = apiLink.reservations.availability({});
const reservationInitiateApiLink = apiLink.reservations.initiate({});
const reservationConfirmApiLink = apiLink.reservations.confirm({});

export interface IReservationAvailabilityArgs {
    propertyId: number;
}

// a 2xx without a handle cannot be continued - it goes through the error path instead of leaving the flow waiting for a code
const isInitiateSuccess = (response: Response, body: Partial<IReservationInitiateResponse> | null) =>
    response.ok && typeof body?.reservation_handle === "string" && body.reservation_handle.length > 0;

export const reservationApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        // Never invalidated: the API caches availability for a while, so a refetch right after a confirm would bring back a stale "available".
        // The outcome of a reservation is patched in with `setReservationAvailability`, and the reserved-by-me marker covers the user's own reservations
        getReservationAvailability: build.query<Record<string, ReservationAvailabilityStatus>, IReservationAvailabilityArgs>({
            query: ({propertyId}) => ({
                url: reservationAvailabilityApiLink(null),
                params: {property: propertyId}
            }),
            // an unexpected body reads as "no status" (CTA hidden) instead of a query that never gets data
            transformResponse: (response: IReservationAvailabilityResponse | null) => response?.properties ?? {},
            // advisory data - a failure only hides the CTA
            transformErrorResponse: transformReservationAvailabilityError,
            keepUnusedDataFor: 60
        }),
        postReservationInitiate: build.mutation<IReservationInitiateResponse, IReservationInitiatePayload>({
            query: (body) => ({
                url: reservationInitiateApiLink(null),
                method: "POST",
                body,
                validateStatus: isInitiateSuccess
            }),
            transformErrorResponse: (response, meta) => transformReservationError(response, "initiate", meta)
        }),
        // any 2xx means the reservation exists, so an empty or incomplete body is still a success
        postReservationConfirm: build.mutation<Partial<IReservationConfirmResponse> | null, IReservationConfirmPayload>({
            query: (body) => ({
                url: reservationConfirmApiLink(null),
                method: "POST",
                body,
                timeout: CONFIRM_TIMEOUT_MS
            }),
            transformErrorResponse: (response, meta) => transformReservationError(response, "confirm", meta)
        })
    }),
    overrideExisting: false
});

export const {useGetReservationAvailabilityQuery, usePostReservationInitiateMutation, usePostReservationConfirmMutation} = reservationApi;

// What the CTA shows once a reservation has been confirmed or has failed for good - patched in place, a refetch could still bring back "available"
export const setReservationAvailability = (propertyId: number, status: ReservationAvailabilityStatus) =>
    reservationApi.util.updateQueryData("getReservationAvailability", {propertyId}, (availability) => {
        availability[String(propertyId)] = status;
    });
import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {CONFIRM_TIMEOUT_MS} from "../constants/reservation_constants";
import {
    IReservationAvailabilityResponse,
    IReservationConfirmPayload,
    IReservationConfirmResponse,
    IReservationInitiatePayload,
    IReservationInitiateResponse
} from "../types/IReservationApi";
import {ReservationAvailabilityStatus} from "../types/ReservationAvailabilityStatus";
import {transformReservationAvailabilityError, transformReservationError} from "../utils/report_reservation_error";

const reservationAvailabilityApiLink = apiLink.reservations.availability({});
const reservationInitiateApiLink = apiLink.reservations.initiate({});
const reservationConfirmApiLink = apiLink.reservations.confirm({});

export interface IReservationAvailabilityArgs {
    propertyId: number;
}

// a 2xx without a handle cannot be continued - it goes through the error path instead of leaving the flow waiting for a code
const isInitiateSuccess = (response: Response, body: Partial<IReservationInitiateResponse> | null) =>
    response.ok && typeof body?.reservation_handle === "string" && body.reservation_handle.length > 0;

export const reservationApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        // Never invalidated: the API caches availability for a while, so a refetch right after a confirm would bring back a stale "available".
        // The outcome of a reservation is patched in with `setReservationAvailability`, and the reserved-by-me marker covers the user's own reservations
        getReservationAvailability: build.query<Record<string, ReservationAvailabilityStatus>, IReservationAvailabilityArgs>({
            query: ({propertyId}) => ({
                url: reservationAvailabilityApiLink(null),
                params: {property: propertyId}
            }),
            // an unexpected body reads as "no status" (CTA hidden) instead of a query that never gets data
            transformResponse: (response: IReservationAvailabilityResponse | null) => response?.properties ?? {},
            // advisory data - a failure only hides the CTA
            transformErrorResponse: transformReservationAvailabilityError,
            keepUnusedDataFor: 60
        }),
        postReservationInitiate: build.mutation<IReservationInitiateResponse, IReservationInitiatePayload>({
            query: (body) => ({
                url: reservationInitiateApiLink(null),
                method: "POST",
                body,
                validateStatus: isInitiateSuccess
            }),
            transformErrorResponse: (response, meta) => transformReservationError(response, "initiate", meta)
        }),
        // any 2xx means the reservation exists, so an empty or incomplete body is still a success
        postReservationConfirm: build.mutation<Partial<IReservationConfirmResponse> | null, IReservationConfirmPayload>({
            query: (body) => ({
                url: reservationConfirmApiLink(null),
                method: "POST",
                body,
                timeout: CONFIRM_TIMEOUT_MS
            }),
            transformErrorResponse: (response, meta) => transformReservationError(response, "confirm", meta)
        })
    }),
    overrideExisting: false
});

export const {useGetReservationAvailabilityQuery, usePostReservationInitiateMutation, usePostReservationConfirmMutation} = reservationApi;

// What the CTA shows once a reservation has been confirmed or has failed for good - patched in place, a refetch could still bring back "available"
export const setReservationAvailability = (propertyId: number, status: ReservationAvailabilityStatus) =>
    reservationApi.util.updateQueryData("getReservationAvailability", {propertyId}, (availability) => {
        availability[String(propertyId)] = status;
    });
